import { render } from "./businessDailyReport.vue?vue&type=template&id=0275cc1c"
import script from "./businessDailyReport.vue?vue&type=script&lang=js"
export * from "./businessDailyReport.vue?vue&type=script&lang=js"

import "./businessDailyReport.vue?vue&type=style&index=0&id=0275cc1c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__